import util from '@/Utils/util';
import type { TableColumnType } from '@/models/table';
import { commonDateTimeFormat } from '@/constants/app';

export const useTable = () => {
  const copyCell = (row: any, column: any, tableColumns: TableColumnType[], specialCopyColumns: string[] = []) => {
    const property = column.property;

    if (property && (specialCopyColumns.length === 0 || specialCopyColumns.includes(property))) {
      let copyString = row[property] || '';
      const tableColumn = tableColumns.find((col: TableColumnType) => col.field === property);

      if (tableColumn) {
        copyString = tableColumn.isDateField ? util.formatDateTime(copyString, commonDateTimeFormat) : copyString;

        util.copyText(copyString, tableColumn.label);
      }
    }
  };

  const getSummaries = (param: any, summaryColumns: string[], summaryTitle: string = 'Total') => {
    const { columns, data } = param;
    const sums: string[] = [];
    columns.forEach((column: any, index: number) => {
      if (index === 0) {
        sums[index] = summaryTitle;
        return;
      }

      if (summaryColumns.includes(column.property)) {
        const values = data.map((item: any) => {
          let value = Number(item[column.property]);

          if (item.children && item.children.length) {
            item.children.map((children: any) => {
              value += Number(children[column.property]);
            });
          }

          return value;
        });

        if (!values.every((value: any) => isNaN(value))) {
          const sum = values.reduce((prev: any, curr: any) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = `$ ${sum.toFixed(2)}`;
        } else {
          sums[index] = '';
        }
      } else {
        return (sums[index] = '');
      }
    });

    return sums;
  };

  return {
    copyCell,
    getSummaries,
  };
};
